// React and related imports
import React from 'react';

// i18 Translation
import { TFunction } from 'i18next';

// Types and Interfaces
import { IQuestion } from '../../common/interfaces/Question.interface';
import { IMultiLanguageValue } from './../../common/interfaces/MultiLanguageValue.interface';

// Custom Components
import {
  MultiLanguageField,
  useMultiLanguageInput,
} from '../Shared/MultiLanguageInput';
import { Card, Label } from 'flowbite-react';
import { LanguageDropdown } from '../Shared/LanguageSelectionDropdown/LanguageDropdown';
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';

interface MultiLangAnswerInputProps {
  t: TFunction<'translation', undefined>;
  question: IQuestion;
  updateQuestionField: (
    field: keyof IQuestion,
    value: IMultiLanguageValue[]
  ) => void;
}

export const MultiLangQuestionInput: React.FC<MultiLangAnswerInputProps> = ({
  t,
  question,
  updateQuestionField,
}) => {
  const { selectedLanguage, setSelectedLanguage } = useMultiLanguageInput();
  const isDarkMode = useAppSelector(selectIsDarkMode);

  return (
    <Card>
      <div className="mb-4">
        <Label value={t('content.selectQuestionLanguage')} className="mb-2" />
        <LanguageDropdown
          selectedLanguage={selectedLanguage}
          onSelectLanguage={setSelectedLanguage}
          isDarkMode={isDarkMode}
        />
      </div>

      <MultiLanguageField
        config={{
          id: 'questionBody-input',
          label: 'content.questionBody',
          type: 'text',
          placeholder: 'placeholders.questionBody',
          required: true,
          autoFocus: true,
          className: 'mt-1',
        }}
        value={question?.body || []}
        onChange={(value) => updateQuestionField('body', value)}
        selectedLanguage={selectedLanguage}
        showLanguageDropdown={false}
        t={t}
        wrapInCard={false}
      />
    </Card>
  );
};
